import { PRODUCT_LINE_CODE } from '../../../../../shared/constants/product-lines-codes';
import { cementBulk } from './cement-bulk';
import { cementBag } from './cement-bag';

export const phConfig = {
  [PRODUCT_LINE_CODE.BULK_CEMENT]: cementBulk,
  [PRODUCT_LINE_CODE.BAG_CEMENT]: cementBag,
};
